<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         

        
    <z-page title="Dashboard Penyata Pemungut Kaunter" class="mt3">
          <w-flex wrap class="mt3" background="royalblue">
            <template v-for="item in datas.status">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.index')+'?lkp_penyata_pemungut_status_id='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template><br><br>

            <template v-for="item in datas.slip_bank">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.index')+'?no_slip_bank='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>

            <template v-for="item in datas.resit_perbendaharaan">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.index')+'?no_resit_perbendaharaan='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>
        </w-flex>
    </z-page>


<!-- ibayaq -->
    <z-page title="Dashboard Penyata Pemungut Ibayaq" class="mt3">
          <w-flex wrap class="mt3" background="royalblue">
            <template v-for="item in datas.status_ibayaq">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_ibayaq')+'?lkp_penyata_pemungut_status_id='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template><br><br>

            <template v-for="item in datas.slip_bank_ibayaq">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_ibayaq')+'?no_slip_bank='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>

            <template v-for="item in datas.resit_perbendaharaan_ibayaq">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_ibayaq')+'?no_resit_perbendaharaan='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>
        </w-flex>
    </z-page>


<!-- ibayaq -->
    <z-page title="Dashboard Penyata Pemungut Kiosk" class="mt3">
          <w-flex wrap class="mt3" background="royalblue">
            <template v-for="item in datas.status_kiosk">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_kiosk')+'?lkp_penyata_pemungut_status_id='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template><br><br>

            <template v-for="item in datas.slip_bank_kiosk">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_kiosk')+'?no_slip_bank='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>

            <template v-for="item in datas.resit_perbendaharaan_kiosk">
              <div class="xs4" >
                <inertia-link :href="$route('kutipan.pemungut.senarai_kiosk')+'?no_resit_perbendaharaan='+item.value"> 
                <z-dashboard-item 
                  class="box sh1 ml1 mb1 "
                  icon="fal fa-file" 
                  icon-color="black-dark1" 
                  subtitle=''>
                  <span class="title black"><b>{{item.label}}</b></span><br>
                  <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                      <w-icon class="mr1" sm>
                        fal fa-calendar
                      </w-icon>
                      <span class="black">{{item.count}}</span>
                  </w-tag><br>
                  
                </z-dashboard-item>
                </inertia-link>
              </div>
            </template>
        </w-flex>
    </z-page>



    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    //  
  },
  data() {
    return {
        resourceurl: this.service_kutipan+'lookup/lkp_status_pemungut',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'iHasil', route: '/' },
        { label: 'Penyata Pemungut', route: '/kutipan/penyat_pemungut' },
        { label: 'Dashboard', route: '/kutipan/penyat_pemungut/dashboard' },
          ],
          form: {
            // id: 0,
            no: '',
            no_dokumen: '',
            },
        }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>